/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import queryString from "query-string";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";

import environment from "constants/apiConst";
import FormMeTrsShow from "../FormShow/FormMeTrsShow";
import TableOrder from "components/Tables/TableOrder";
import ConfigurationHeader from "../ConfigurationHeader";
import Pagination from "components/Pagination/Pagination";
import TbodyTransportMethod from "../tables/TbodyTransportMethod";
import { SectionContainerGene } from "styled/SectionContainer.styled";
import ConfigurationCRUDContext from "context/ConfigurationCRUDContext";
import { __TransportMethod } from "request/configuration/__TransportMethod";
import TransportMethodForm from "../forms/TransportMethodForm";
import { useGlobalContext } from "context/GlobalContext";
import { useQuery } from "@tanstack/react-query";

const TransportMethod = () => {
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [currentPage, setCurrentPage] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const freeZone_id = useSelector((state) => state.auth.dataUser.token);
  const {
    setRequestEdit,
    setRequestCreate,
    setRequestDelete,
    setFormShow,
    setFormEdit,
    update
  } = useContext(ConfigurationCRUDContext);

  const location = useLocation();
  const { q = "" } = queryString.parse(location.search);

  const thead = [
    { name: "Código", order: "code_transportMethod" },
    { name: "Nombre", order: "name_transportMethod" },
    { name: "Estado", order: "status_transportMethod" },
    { name: "Acciones", order: "" }
  ];

  const formEdit = () => {
    return <TransportMethodForm />;
  };

  const formShow = () => {
    return <FormMeTrsShow />;
  };

  useEffect(() => {
    setFormEdit(formEdit);
    setFormShow(formShow);
    setRequestEdit(environment.TRANSPORT_METHOD_UPDATE);
    setRequestCreate(environment.TRANSPORT_METHOD_CREATE);
    setRequestDelete(environment.TRANSPORT_METHOD_DELETE);
  }, [q, update, page]);


  const { requestData } = useGlobalContext();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["configTransportMethod", page, q, freeZone_id, update],
    queryFn: () => requestData({
      Endpoint: environment.TRANSPORT_METHOD_GET,
      pageParam: page,
      ...(q?.length !== 0 && { data: { search: q } }),
      PropertyBody: "sendJSONContentPOST",
    })
  })

  useEffect(() => {
    if (data?.data?.status?.code !== 200) return;
    if (data?.data?.status?.data?.last_page < page) setPage(1);
  }, [data?.data?.status?.data?.last_page])

  return (
    <SectionContainerGene>
      <ConfigurationHeader title="Métodos de transporte"></ConfigurationHeader>
      {loading || (
        <TableOrder
          thead={thead}
          data={data?.data?.status?.code === 200 ? data?.data?.status?.data?.data : []}
          setData={setCurrentPage}
          loading={isLoading}
          tbodyData={TbodyTransportMethod}
        />
      )}
      <Pagination
        page={page}
        setPage={setPage}
        maxPage={data?.data?.status?.code === 200 ? data?.data?.status?.data?.last_page : 1}
        loading={isLoading}
      />
    </SectionContainerGene>
  );
};

export default TransportMethod;
